const greekPrefectures = [
	"Αττική",
	"Θεσσαλονίκη",
	"Αιτωλοακαρνανίας",
	"Αργολίδας",
	"Αρκαδίας",
	"Άρτας",
	"Αχαΐας",
	"Βοιωτίας",
	"Γρεβενών",
	"Δράμας",
	"Δωδεκανήσου",
	"Έβρου",
	"Εύβοιας",
	"Ευρυτανίας",
	"Ζακύνθου",
	"Ηλείας",
	"Ημαθίας",
	"Ηρακλείου",
	"Θεσπρωτίας",
	"Ιωαννίνων",
	"Καβάλας",
	"Καρδίτσας",
	"Καστοριάς",
	"Κέρκυρας",
	"Κεφαλληνίας",
	"Κιλκίς",
	"Κοζάνης",
	"Κορινθίας",
	"Κυκλάδων",
	"Λακωνίας",
	"Λάρισας",
	"Λασιθίου",
	"Λέσβου",
	"Λευκάδας",
	"Μαγνησίας",
	"Μεσσηνίας",
	"Ξάνθης",
	"Πέλλας",
	"Πιερίας",
	"Πρέβεζας",
	"Ρεθύμνης",
	"Ροδόπης",
	"Σάμου",
	"Σερρών",
	"Τρικάλων",
	"Φθιώτιδας",
	"Φλώρινας",
	"Φωκίδας",
	"Χαλκιδικής",
	"Χανίων",
	"Χίου",
];

export default greekPrefectures;
